
import UnitModel from '@/_models/UnitModel'
import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import TablePagination from '@/components/shared/TablePagination.vue'
import FilterDropdown from '@/components/shared/FilterDropdown.vue'
import NotFound from '@/components/common/NotFound.vue'
import AskForDetele from '@/components/partials/AskForDelete.vue'

import { UnitStoreAction, UnitSelection } from '@/_consts/UnitStoreAction'

@Component({
  components: { TablePagination, FilterDropdown, NotFound },
  computed: {
    ...mapGetters('units', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('units', {
      canDelete: 'canDelete',
    }),
  },
})
export default class ListingMixin extends Vue {
  public pageFilters: any = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'name',
    searchQuery: '',
  }
  public numofPage: number = 1
  public checkboxPosition: string = 'left'
  public checkedRows: any[] = []

  public tableSortSettings: [string, string] = ['', 'asc']

  public filedNameLUT: any = {}

  // computed
  get selected(): UnitModel {
    const item = this.$store.state.units.item
    if (!item.api_keys) {
      item.api_keys = []
    }

    return item
  }

  get isLoading(): boolean {
    return this.$store.state.units.loading
  }

  // methods
  public convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  public handleConfirmMultipleDelete(type: UnitSelection, ids: string[], label: string[]) {
    const selectStorePath = UnitStoreAction[type]
    
    const deleteModal = this.$buefy.modal.open({
      parent: this,
      component: AskForDetele,
      hasModalCard: true,
      customClass: 'custom-class custom-class-2',
      trapFocus: true,
      props: {
        data: label,
        hasRef: selectStorePath.hasRef,
        type: selectStorePath.type,
        idsProp: ids,
        unit: this.selected
      },
      events: {
        onDelete: () => {
          const payload = {
            unit: { db_name: this.selected.db_name },
            ids: [...ids],
            collection: selectStorePath.type
          }
          this.processDelete(payload)
        }
      }
    })
  }

  public processDelete(payload: any): void {
    this.$store.dispatch('units/deleteMany', payload).then(() => {
      this.checkedRows = []
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }
}
